export default __webpack_public_path__ + "static/media/master_classes.7b03f90c.svg";